import React from "react";

import { LoadState } from "@/lib/scan-ui/screen";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";

const TITLE = "Дашборд склада";
const SUBTITLE = "Что показывать на вкладках дашборда.";

/** Настройки дашборда склада: юрлица, скрытые в «Сроках годности». */
export function WarehouseDashboardSettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader title={TITLE} subtitle={SUBTITLE} />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader title={TITLE} subtitle={SUBTITLE} />
      <OrgWhitelistCard
        title="Юрлица, скрытые в «Сроках годности»"
        description="Их блоков на вкладке не будет — под блоками останется строка «Скрыто настройкой» с количеством. На «Остатки» и «Обзор» не влияет."
        hint="Отметьте юрлица, которые не нужно показывать. Ничего не отмечено — показываются все."
        emptyLabel="никто"
        field="dashboard_hidden_organization_refs"
        current={data.dashboard_hidden_organization_refs}
      />
    </div>
  );
}
